import React from 'react';
import gettext from '@eb/gettext';

import { Organizer } from '../../types';

import { removeInlineStyleTags } from './utils';

import './Header.scss';

export interface HeaderProps {
    organizer: Organizer;
    website: string;
    customStyle: {
        text_color: string;
        background_color: string;
    };
}

const Image = (props: { src: string }) => {
    if (!props.src) {
        return null;
    }

    return (
        <div className="eds-g-cell eds-g-cell-4-12 eds-g-cell-sm-3-12 eds-g-cell-sw-3-12 eds-g-cell-mn-2-12">
            <div className="organizer-profile-header__image--container">
                <img
                    className="organizer-profile-header__image"
                    src={props.src}
                    alt={gettext('Organizer profile image')}
                />
            </div>
        </div>
    );
};

const Title = (props: { children: any; textColor: string }) => {
    return (
        <h1
            className="eds-text-hm eds-l-mar-top-4"
            style={{ color: props.textColor }}
        >
            {props.children}
        </h1>
    );
};

const Website = (props: { children: any }) => {
    if (!props.children) {
        return null;
    }

    return <section>{props.children}</section>;
};

const Description = (props: { content: string }) => {
    if (!props.content) {
        return null;
    }

    const cleanedContent = removeInlineStyleTags(props.content);

    return (
        <div
            className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-8-12 eds-l-mar-top-3"
            dangerouslySetInnerHTML={{ __html: cleanedContent }}
        />
    );
};

export const Header: React.FunctionComponent<HeaderProps> = (props) => {
    const textColor = `${props.customStyle.text_color}`;
    const backgroundColor =
        props.customStyle.background_color === '#f8f8fa'
            ? '#fffff'
            : `${props.customStyle.background_color}`;

    return (
        <header
            style={{
                color: textColor,
                backgroundColor: backgroundColor,
            }}
            className="organizer-profile-header"
        >
            <Image src={props.organizer?.logo?.url} />
            <Title textColor={textColor}>{props.organizer.name}</Title>
            <Website>
                <a style={{ color: textColor }} href={props.website}>
                    {props.website}
                </a>
            </Website>
            <Description content={props.organizer.long_description.html} />
        </header>
    );
};
